import React from "react";
import { NavLink } from "react-router-dom";
import { Home, Search, Store, Bell, User } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const MobileNav = () => {
  const { user } = useAuth();
  const dash = user?.role === "admin" ? "/admin" : user?.role === "seller" ? "/seller" : user ? "/orders" : "/login";
  const items = [
    { to: "/", icon: Home, label: "الرئيسية", testid: "mnav-home" },
    { to: "/search", icon: Search, label: "بحث", testid: "mnav-search" },
    { to: "/yards", icon: Store, label: "التشاليح", testid: "mnav-yards" },
    { to: "/notifications", icon: Bell, label: "إشعارات", testid: "mnav-notif" },
    { to: dash, icon: User, label: "حسابي", testid: "mnav-account" },
  ];
  return (
    <nav className="md:hidden fixed bottom-0 inset-x-0 z-50 glass border-t" style={{ borderColor: "var(--border-c)" }}>
      <div className="grid grid-cols-5">
        {items.map(({ to, icon: Icon, label, testid }) => (
          <NavLink key={testid} to={to} data-testid={testid} end={to === "/"}
            className={({ isActive }) => `flex flex-col items-center gap-1 py-2.5 text-[10px] ${isActive ? "text-[var(--amber)]" : "text-[var(--text-muted)]"}`}>
            <Icon size={20} />
            {label}
          </NavLink>
        ))}
      </div>
    </nav>
  );
};
